import React from 'react';
import moment from 'moment';
import { Button, Col, Label, Row } from 'reactstrap';
import CardWithTitle from 'components/CardWithTitle';
import productImg from 'assets/product-img.png';
import { splitNameFromUrl } from 'helper/utils';
import 'pages/Products/components/ProductDetailsMobile.css';

const ProductDetails = ({ productDetails }) => {
  const getFirstFile = (value) => {
    if (!value) return '';
    return Array.isArray(value) ? value[0] : value;
  };

  const downloadFile = async (fileUrl, fileName) => {
    if (!fileUrl) return;
    try {
      const response = await fetch(fileUrl);
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = fileName;
      link.click();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Error downloading file:', error);
    }
  };

  const photoUrl = getFirstFile(productDetails?.photo);
  const documentUrl = getFirstFile(productDetails?.document);
  const documentName = documentUrl ? splitNameFromUrl(documentUrl) : '';

  return (
    <CardWithTitle title="General Details" className="product-detail-card">
      <Row className="mb-2 align-items-center product-detail-grid">
        <Col xs={4} xl={3}>
          <div className="product-info product-detail-media d-flex align-items-center">
            <img src={photoUrl || productImg} alt="product" />
            <div className="ms-3 ms-xxl-4">
              <Label className="f-12 text-uppercase fw-medium text-gray  d-block mb-0">
                Product
              </Label>
              <p className="f-14 mb-0 text-capitalize text-break product-detail-value">
                {productDetails?.name || 'Not Available'}
              </p>
            </div>
          </div>
        </Col>
        <Col xs={3} xl={2}>
          <Label className="f-12 text-uppercase fw-medium text-gray d-block mb-0">
            Category
          </Label>
          <p className="f-12 mb-0 text-capitalize product-detail-value">
            {productDetails?.category?.name || 'Not Available'}
          </p>
        </Col>
        <Col xs={3} xl={2}>
          <Label className="f-12 text-uppercase fw-medium text-gray d-block mb-0">
            Published On
          </Label>
          <p className="f-12 mb-0 product-detail-value">
            {productDetails?.createdAt
              ? moment(productDetails.createdAt).format('D MMM, YYYY HH:mm A')
              : 'Not Available'}
          </p>
        </Col>
        <Col xs={3} xl={1}>
          <Label className="f-12 text-uppercase fw-medium text-gray d-block mb-0">
            Status
          </Label>
          <p className="f-12 mb-0 product-detail-value">
            {productDetails?.status || 'Not Available'}
          </p>
        </Col>
        <Col xs={3} xl={2}>
          <Label className="f-12 text-uppercase fw-medium text-gray d-block mb-0">
            Documents
          </Label>
          {documentUrl ? (
            <Button
              color="link"
              className="p-0 f-12 text-decoration-none text-start product-detail-value"
              onClick={() => downloadFile(documentUrl, documentName)}
            >
              {documentName}
            </Button>
          ) : (
            <p className="f-12 mb-0 product-detail-value">Not Available</p>
          )}
        </Col>
      </Row>
    </CardWithTitle>
  );
};

export default ProductDetails;
